import * as React from 'react'
import { FC } from 'react'
import { LocationsPopoverContentSelectorProps } from '../../typings'
import { EntityLocationsPopoverContentWrapper } from './EntityLocationsPopoverContentWrapper'
import { SelectedLocationsPopoverContentWrapper } from './SelectedLocationsPopoverContentWrapper'

export const LocationsPopoverContentSelector: FC<
  LocationsPopoverContentSelectorProps
> = (props) => {
  switch (props.variant) {
    case 'entity':
      return <EntityLocationsPopoverContentWrapper {...props} />
    case 'selected':
      return <SelectedLocationsPopoverContentWrapper {...props} />
  }
}
